/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExecutionStatus } from './ExecutionStatus';
import {
    ExecutionStatusFromJSON,
    ExecutionStatusFromJSONTyped,
    ExecutionStatusToJSON,
    ExecutionStatusToJSONTyped,
} from './ExecutionStatus';

/**
 * 
 * @export
 * @interface GetTaskResponse
 */
export interface GetTaskResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTaskResponse
     */
    workItemId: string;
    /**
     * 
     * @type {string}
     * @memberof GetTaskResponse
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof GetTaskResponse
     */
    taskName: string;
    /**
     * 
     * @type {ExecutionStatus}
     * @memberof GetTaskResponse
     */
    status: ExecutionStatus;
    /**
     * 
     * @type {string}
     * @memberof GetTaskResponse
     */
    createdBy: string;
    /**
     * 
     * @type {string}
     * @memberof GetTaskResponse
     */
    taskDescription: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetTaskResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetTaskResponse
     */
    updatedAt: Date | null;
}



/**
 * Check if a given object implements the GetTaskResponse interface.
 */
export function instanceOfGetTaskResponse(value: object): value is GetTaskResponse {
    if (!('workItemId' in value) || value['workItemId'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('taskName' in value) || value['taskName'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('taskDescription' in value) || value['taskDescription'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetTaskResponseFromJSON(json: any): GetTaskResponse {
    return GetTaskResponseFromJSONTyped(json, false);
}

export function GetTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'workItemId': json['workItemId'],
        'entityName': json['entityName'],
        'taskName': json['taskName'],
        'status': ExecutionStatusFromJSON(json['status']),
        'createdBy': json['createdBy'],
        'taskDescription': json['taskDescription'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

export function GetTaskResponseToJSON(json: any): GetTaskResponse {
    return GetTaskResponseToJSONTyped(json, false);
}

export function GetTaskResponseToJSONTyped(value?: GetTaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workItemId': value['workItemId'],
        'entityName': value['entityName'],
        'taskName': value['taskName'],
        'status': ExecutionStatusToJSON(value['status']),
        'createdBy': value['createdBy'],
        'taskDescription': value['taskDescription'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

